// extracted by mini-css-extract-plugin
export default {"display":"h","title":"i","link":"j","linkWrapper":"k"};